export const OtpSheet = {
    mounted() {
        document.getElementById("otp-input")?.addEventListener("input", (e) => {
            if (document.getElementById("otp-input").value.length === 6) {
                document.getElementById("otp-input").blur();
            }
        });

        document.getElementById("otp-input")?.addEventListener("change", (e) => {
            if (document.getElementById("otp-input").value.length === 6) {
                document.getElementById("otp-input").blur();
            }
        });
    },
};
